import { Link, Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import Icon from "@mui/material/Icon";
import { ReactNode } from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { BreadCrumb } from "@/types/page.types";

interface BreadcrumbsProps {
  icon: ReactNode;
  title: string;
  light?: boolean;
  breadcrumbs?: BreadCrumb[];
  compact?: boolean;
  hideBoldTitle?: boolean;
}
function Breadcrumbs({
  icon,
  title,
  breadcrumbs,
  light = false,
  compact = false,
  hideBoldTitle = false,
}: BreadcrumbsProps) {
  return (
    <MDBox mr={compact ? 0 : { xs: 0, xl: 8 }}>
      <MuiBreadcrumbs
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: ({ palette: { white, grey } }) => (light ? white.main : grey[600]),
          },
        }}
      >
        <Link href="/">
          <MDTypography
            component="span"
            variant="body2"
            color={light ? "white" : "dark"}
            opacity={light ? 0.8 : 0.5}
            sx={{ lineHeight: 0 }}
          >
            <Icon sx={compact ? { fontSize: '0.9rem !important' } : {}}>{icon}</Icon>
          </MDTypography>
        </Link>
        {breadcrumbs &&
          breadcrumbs.map((el) => (
            <Link href={el.href} key={`breadcrumb-${el.title}`}>
              <MDTypography
                component="span"
                variant="button"
                fontWeight="regular"
                textTransform="capitalize"
                color={light ? "white" : "dark"}
                opacity={light ? 0.8 : 0.5}
                sx={{ lineHeight: 0, ...(compact ? { fontSize: '0.7rem' } : {}) }}
              >
                {el.title}
              </MDTypography>
            </Link>
          ))}
        <MDTypography
          variant="button"
          fontWeight="regular"
          textTransform="none"
          color={light ? "white" : "dark"}
          sx={{ lineHeight: 0, ...(compact ? { fontSize: '0.7rem' } : {}) }}
        >
          {title.replace("-", " ")}
        </MDTypography>
      </MuiBreadcrumbs>
      {!hideBoldTitle && (
        <MDTypography
          fontWeight="bold"
          textTransform="none"
          variant="h6"
          color={light ? "white" : "dark"}
          noWrap
          sx={compact ? { fontSize: "0.8rem" } : {}}
        >
          {title.replace("-", " ")}
        </MDTypography>
      )}
    </MDBox>
  );
}

export default Breadcrumbs;
